import { getDatalists } from "features/datalist";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Person, Stakeholder } from "services/person/person.types";

export const useStakeholdersTabVM = (person: Person) => {
    const navigate = useNavigate();
    const datalists = useSelector(getDatalists);

    const editStakeholder = (stakeholder: Stakeholder) => {
        navigate(`/app/admin/persons/${person?.id}/stakeholders/${stakeholder.id}/edit`)
    }

    return {
        person,
        datalists,
        editStakeholder
    }
}
